import styled from 'styled-components';

type NotificationDotProps = {
  dataTest?: string;
};

const NotificationDot = styled.div.attrs<NotificationDotProps>(({ dataTest }) => ({
  'data-test': dataTest,
}))<NotificationDotProps>`
  width: 10px;
  height: 10px;
  background-color: ${({ theme }) => theme.orbit.borderColorButtonCriticalBordered};
  border-radius: 50%;
`;

export default NotificationDot;
